import Reconciliation from "./pages/reconciliation";
import ReconciliationDetail from "./pages/reconciliation-detail";
import Admin from "./pages/admin";
import Error from "./pages/error";

export default [
  {
    path: "/",
    exact: true,
    component: Reconciliation
  },
  {
    path: "/reconciliation-detail/:kukey/:record",
    exact: true,
    component: ReconciliationDetail
  },
  {
    path: "/admin",
    exact: true,
    component: Admin
  },
  {
    exact: true,
    component: Error
  }
];
